<template>
  <div class="content">
    <el-form :inline="true" style="margin: 20px 0">
      <el-button class="addBtn" type="primary" size="small" @click="handleAdd">新增</el-button>
      <el-form-item label="护士称呼: " style="margin: 0 20px" size="small">
        <el-input v-model="listQuery.name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small">搜索</el-button>
    </el-form>
    <!-- 分类表格 -->
    <el-table
      border
      :data="tableData"
      style="width: 100%; overflow-y: scroll !important"
      height="calc(100vh - 220px)"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-text="正在加载中"
    >
      <el-table-column type="index" label="序号" align="center" width="180"></el-table-column>
      <el-table-column label="护士图" width="120" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 30px; height: 30px; border-radius: 5px"
            :src="scope.row.img"
            :preview-src-list="[scope.row.img]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="护士称呼" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>

      <el-table-column label="服务价格" width="120" align="center">
        <template slot-scope="scope">{{ scope.row.price }} 元</template>
      </el-table-column>

      <el-table-column label="服务内容" align="center">
        <template slot-scope="scope">{{ scope.row.detail }}</template>
      </el-table-column>

      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.row)" primary>修改</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0)"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <el-form-item label="护士名称" required>
          <el-input v-model="dialogForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话" required>
          <el-input v-model="dialogForm.phone" clearable></el-input>
        </el-form-item>
        <el-form-item label="服务描述" required>
          <el-input v-model="dialogForm.detail" clearable type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="服务价格" required>
          <el-input v-model="dialogForm.price" clearable type="number"></el-input>
        </el-form-item>
        <el-form-item label="最大预约数">
          <el-input v-model="dialogForm.maxNum" clearable type="number"></el-input>
        </el-form-item>
        <el-form-item label="护士头像" required>
          <el-input v-model="dialogForm.img" clearable></el-input>
        </el-form-item>

        <el-form-item label="护士头像" width="100">
          <div class="demo-image__preview">
            <el-image
              style="width: 100px; height: 100px"
              :src="dialogForm.img"
              :preview-src-list="[dialogForm.img]"
            ></el-image>
          </div>
        </el-form-item>
        <el-form-item label="上传">
          <el-upload
            class="upload-demo"
            :action="action"
            :multiple="true"
            :on-success="handleSuccess_cover"
            :file-list="fileList"
            list-type="picture"
            name="formData"
          >
            <el-button class="addBtn" size="small" type="primary">上传护士主图</el-button>
            <div slot="tip" class="el-upload__tip">上传jpg/png文件，500px X 500px, 会自动覆盖原来的图片</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="addBtn" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectNurse,
  updateNurse,
  deleteNurse,
  addNurse
} from "@/services/nurse/index";
import { IP } from "@/services/index.js";
export default {
  created() {
    this.getListData();
  },
  data() {
    return {
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: ""
      },
      goodsTitle: "",
      tableData: [],
      dialogFormVisible: false,
      dialogForm: {},
      inpitTypeName: "",
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: false,
      pageCount: "",
      pageSize: 8,
      form: {
        productNurse: 1
      },
      status: 0
    };
  },
  methods: {
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectNurse(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    handleAdd(type) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增护士";
      this.fileList = [];
      this.dialogForm = {};
      this.isaddNurseselectNurseOne = 1;
    },

    /* 修改 */
    handleEdit(row) {
      this.fileList = [];
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改护士";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      // if (this.dialogForm.store_id) {
      //   this.dialogForm.store_id = this.dialogForm.store_id?.split(",");
      // }
    },

    handleSuccess_cover(e) {
      this.dialogForm.img = e.data;
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (
        !this.dialogForm.name ||
        !this.dialogForm.phone ||
        !this.dialogForm.detail ||
        !this.dialogForm.price
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.inpitTypeName == "新增护士") {
        addNurse({ ...this.dialogForm }).then(res => {
          if (res.code) {
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
      if (this.inpitTypeName == "修改护士") {
        updateNurse(this.dialogForm).then(resp => {
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm(`此操作将永久删除'${row.name}'护士吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteNurse({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.content {
  margin: 20px auto;
  width: 96%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
</style>
